export const bucketListItems = [
  {
    category: "Travel",
    items: [
      { text: "Visit Japan during cherry blossom season", completed: false },
      { text: "See the Northern Lights in Iceland", completed: false },
      { text: "Make the Camino de Santiago", completed: false },
      { text: "Come back to Riga", completed: false },
      { text: "Stay in an overwater bungalow in Maldives", completed: false },
      { text: "Go on an African safari", completed: false },
      { text: "Visit Machu Picchu in Peru", completed: false },
      { text: "Visit San Francisco", completed: false },
      { text: "Visit Los Angeles", completed: false },
      { text: "See the Pyramids in Egypt", completed: false },
      { text: "Road trip across the United States", completed: false },
      { text: "Visit Antarctica", completed: false },
      { text: "Trek to Everest Base Camp", completed: false },
      { text: "Experience Carnival in Rio", completed: false },
      { text: "Visit the Great Wall of China", completed: false },
      { text: "See the Taj Mahal at sunrise", completed: false }
    ]
  },
  {
    category: "Personal Growth",
    items: [
      { text: "Learn three foreign languages fluently", completed: false },
      { text: "Write and publish a book", completed: false },
      { text: "Give a TED Talk", completed: false },
      { text: "Start a successful company", completed: false },
      { text: "Learn to play a musical instrument", completed: false },
      { text: "Master meditation", completed: false },
      { text: "Get a bachelor's degree", completed:  true},
      { text: "Get a master's degree", completed:  true},
      { text: "Make an Erasmus", completed:  true },
      { text: "Learn photography", completed: false },
      { text: "Master public speaking", completed: false },
      { text: "Stick my sticker at the Valhalla in Riga", completed: false },
      { text: "Help my mum to win against her cancer", completed: true },
      { text: "Become financially independent", completed: false },
      { text: "Mentor someone to success", completed: false }
    ]
  },
  {
    category: "Adventure & Sports",
    items: [
      { text: "Run a half marathon", completed: true },
      { text: "Run a marathon", completed: false },
      { text: "Enter in hall of fame Riga runners", completed: false },
      { text: "Run a three marathons in a year", completed: false },
      { text: "Learn to surf", completed: false },
      { text: "Go scuba diving", completed: true },
      { text: "Climb a major mountain", completed: false },
      { text: "Go bungee jumping", completed: false },
      { text: "Complete a triathlon", completed: false },
      { text: "Go white water rafting", completed: false },
      { text: "Learn to snowboard", completed: false },
      { text: "Go paragliding", completed: false },
      { text: "Race on a race track", completed: false },
      { text: "Go helicopter skiing", completed: false },
      { text: "Complete an obstacle course race", completed: false }
    ]
  },
  {
    category: "Career & Achievement",
    items: [
      { text: "Create a successful AI/ML project", completed: false },
      { text: "Contribute to open source", completed: true },
      { text: "Patent an invention", completed: false },
      { text: "Build a popular app", completed: false },
      { text: "Speak at a major tech conference", completed: false },
      { text: "Write a technical book", completed: false },
      { text: "Create an online course", completed: false },
      { text: "Build a successful portfolio", completed: false },
      { text: "Lead a major project", completed: false },
      { text: "Start a tech blog with 10k followers", completed: false },
      { text: "Make an exit from a startup", completed: false },
      { text: "Win a hackathon", completed: true},
      { text: "Create a successful open source project", completed: true },
      { text: "Having 20k stars on github on a single project", completed: true },
      { text: "Mentor junior developers", completed: false }
    ]
  },
  {
    category: "Lifestyle & Experiences",
    items: [
      { text: "Meet Elon Musk", completed: false },
      { text: "Meet Jordan Peterson", completed: false },
      { text: "Attend a major film festival", completed: false },
      { text: "Go to all major tech conferences", completed: false },
      { text: "Have dinner at a 3-star Michelin restaurant", completed: false },
      { text: "Learn astronomy and stargaze in the desert", completed: false },
      { text: "Build a smart home", completed: false },
      { text: "Create a personal library", completed: false },
      { text: "Learn to fly a drone", completed: false },
      { text: "Create a time capsule", completed: false },
      { text: "Plant and grow a garden", completed: false },
      { text: "Learn bartending", completed: false },
      { text: "Master chess", completed: false },
      { text: "Create a family tree", completed: false },
      { text: "Learn calligraphy", completed: false }
    ]
  },
  {
    category: "Giving Back",
    items: [
      { text: "Start a scholarship fund", completed: false },
      { text: "Volunteer abroad", completed: false },
      { text: "Teach coding to underprivileged kids", completed: false },
      { text: "Plant 10 trees", completed: false },
      { text: "Start a non-profit organization", completed: false },
      { text: "Build homes for those in need", completed: false },
      { text: "Create free educational content", completed: false },
      { text: "Organize a charity event", completed: false },
      { text: "Support a child's education", completed: false },
      { text: "Create jobs through entrepreneurship", completed: false },
      { text: "Start a community garden", completed: false },
      { text: "Organize a coding bootcamp", completed: false },
      { text: "Create a mentorship program", completed: false },
      { text: "Fund a research project", completed: false },
      { text: "Build a community center", completed: false }
    ]
  },
  {
    category: "Relationships",
    items: [
      { text: "Create a family", completed: false },
      { text: "Create lasting friendships in 10 countries", completed: true },
      { text: "Write letters to future self", completed: false },
      { text: "Create a family tradition", completed: false },
      { text: "Record family stories", completed: false },
      { text: "Create a legacy project", completed: false },
      { text: "Build a strong network", completed: true },
      { text: "Be a great mentor", completed: false },
      { text: "Strengthen family bonds", completed: false },
      { text: "Create meaningful partnerships", completed: false }
    ]
  }
]; 